"use client";
import { useState } from "react";

// Ajusta este import y tipo a tu estructura real:
import { ProductCharacteristic } from "@/@types";

// Estos componentes ya los usabas en tu versión con tabs.
// Los importas como siempre:
import ProductTabSpec from "./ProductTabSpec";
import ProductTabInfo from "./ProductTabInfo";
import ProductTabDocuments from "./ProductTabDocuments";
import ProductTabVideos from "./ProductTabVideos";

type ProductsAccordeonProps = {
  features?: ProductCharacteristic[];
  info?: string;
  videos?: any[];     // Ajusta el tipo si deseas algo más estricto
  documents?: any[];  // Igual aquí
  activeUnit: "EE.UU" | "MÉTRICAS";
};

export default function ProductsAccordeon({
  features = [],
  info,
  videos = [],
  documents = [],
  activeUnit
}: ProductsAccordeonProps) {
  // Guarda la key de la sección actualmente abierta. Si está en null, ninguna está abierta.
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  // Cambia entre abrir/cerrar una sección
  const toggleAccordion = (key: string) => {
    setOpenAccordion(prev => (prev === key ? null : key));
  };

  // Helper para saber si una sección está abierta
  const isOpen = (key: string) => openAccordion === key;

  return (
    <div className="lg:hidden w-full">
      
      {/* ================== ESPECIFICACIONES ================== */}
      <div>
        <button
          onClick={() => toggleAccordion("especificaciones")}
          className={`
            w-full flex items-center justify-between px-4 py-3
            ${isOpen("especificaciones")
              ? "bg-yellow00 border-none"
              : "bg-gray01 border-b border-gray02"
            }
            transition-colors
          `}
        >
          <span className="font-bold text-left">
            ESPECIFICACIONES
          </span>

          {/* Flecha (SVG) apuntando hacia abajo por defecto,
              rotada 180° si está abierto */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`
              h-5 w-5 transform transition-transform 
              ${isOpen("especificaciones") ? "rotate-180" : ""}
            `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {isOpen("especificaciones") && (
          <div className="px-4 py-3 border-b border-gray02">
            {features.length > 0 ? (
              <ProductTabSpec features={features} activeUnit={activeUnit}/>
            ) : (
              <p className="font-bold">Sin información de especificaciones</p>
            )}
          </div>
        )}
      </div>

      {/* ================== INFORMACIÓN GENERAL ================== */}
      <div>
        <button
          onClick={() => toggleAccordion("info")}
          className={`
            w-full flex items-center justify-between px-4 py-3
            ${isOpen("info")
              ? "bg-yellow00 border-none"
              : "bg-gray01 border-b border-gray02"
            }
            transition-colors
          `}
        >
          <span className="font-bold text-left">
            INFORMACIÓN GENERAL
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`
              h-5 w-5 transform transition-transform 
              ${isOpen("info") ? "rotate-180" : ""}
            `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {isOpen("info") && (
          <div className="px-4 py-3 border-b border-gray02 text-justify">
            {info ? (
              <ProductTabInfo info={info} />
            ) : (
              <p className="font-bold">Sin información general</p>
            )}
          </div>
        )}
      </div>

      {/* ================== FOLLETOS ================== */}
      <div>
        <button
          onClick={() => toggleAccordion("docs")}
          className={`
            w-full flex items-center justify-between px-4 py-3
            ${isOpen("docs")
              ? "bg-yellow00 border-none"
              : "bg-gray01 border-b border-gray02"
            }
            transition-colors
          `}
        >
          <span className="font-bold text-left">
            FOLLETOS
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`
              h-5 w-5 transform transition-transform 
              ${isOpen("docs") ? "rotate-180" : ""}
            `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {isOpen("docs") && (
          <div className="px-4 py-3 border-b border-gray02">
            {documents.length > 0 ? (
              <ProductTabDocuments documents={documents} />
            ) : (
              <p className="font-bold">Sin información de folletos</p>
            )}
          </div>
        )}
      </div>

      {/* ================== VIDEOS ================== */}
      <div>
        <button
          onClick={() => toggleAccordion("videos")}
          className={`
            w-full flex items-center justify-between px-4 py-3
            ${isOpen("videos")
              ? "bg-yellow00 border-none"
              : "bg-gray01 border-b border-gray02"
            }
            transition-colors
          `}
        >
          <span className="font-bold text-left">
            VIDEOS
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`
              h-5 w-5 transform transition-transform 
              ${isOpen("videos") ? "rotate-180" : ""}
            `}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {isOpen("videos") && (
          <div className="px-4 py-3 border-b border-gray02">
            {videos.length > 0 ? (
              <ProductTabVideos videos={videos} />
            ) : (
              <p className="font-bold">Sin información de videos</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
